<template>
<div class="about">
    <v-header />
    <v-sidebar />
    <div class="content-box-region">
        <div class="content">
            <div>
                <div class="container">
                    <div class="handle-box">
                        <el-select v-model="query.country" allow-create filterable clearable style="width: 160px;" placeholder="请选择或输入国家" @change="handleChange">
                            <el-option v-for="item in countrylist" :key="item.id" :label="item.title" :value="item.title">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.region" allow-create filterable clearable style="width: 160px;" placeholder="请选择或输入地区">
                            <el-option v-for="item in regionlist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>

                        <el-button type="primary" icon="el-icon-search" style="margin: 5px; width: 120px;" @click="handleSearch">搜索</el-button>
                    </div>
                    <div class="filter-container-right">

                        <el-button v-waves class="filter-item" style="margin-left: 5px; width: 90px;" type="primary" icon="el-icon-plus" @click="handleAdd">
                            添加
                        </el-button>

                        <el-button class="filter-item" type="primary" style="margin-left: 10px; width: 90px;" icon="el-icon-upload2" data-step="5" @click="importDetail">
                            导入
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width: 120px;" class="filter-item" type="primary" icon="el-icon-download" @click="handleExportSome">
                            导出选中
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width: 120px;" class="filter-item" type="primary" icon="el-icon-download" @click="handleExport">
                            全部导出
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width:120px" class="filter-item" type="danger" icon="el-icon-delete" :disabled="lander.role!=='100' " @click="handleDeleteSelect">
                            删除选中
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width:120px" class="filter-item" type="danger" icon="el-icon-delete" :disabled="lander.role!=='100' " @click="handleDeleteAll">
                            全部删除
                        </el-button>

                    </div>
                    <el-table :data="tableData" border fit style="width: 100%;" class="table" ref="table" header-cell-class-name="table-header" size="mini" v-loading="listLoading" row-class-name="success-row" stripe @selection-change="handleRowSelect" @row-click="handleClick">
                        <el-table-column prop="selects" type="selection" label="选择" width="50" align="center" />
                        <el-table-column fixed type="index" width="50" label="序号" align="center" />
                        <el-table-column fixed prop="country" label="国家" align="center"></el-table-column>
                        <el-table-column fixed prop="region" label="一级地区" align="center"></el-table-column>
                        <el-table-column fixed prop="region2" label="二级地区" align="center"></el-table-column>
                        <el-table-column prop="remark" label="备注" width="140" align="center"></el-table-column>
                        <el-table-column label="操作" width="190px" fixed="right" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" icon="el-icon-edit" :disabled="lander.role!=='100'" @click="handleEdit(scope.row)">
                                    修改
                                </el-button>
                                <el-button size="mini" class="filter-item" style="margin-left: 5px;" type="danger" icon="el-icon-delete" :disabled="lander.role!=='100' " @click="handleDelete(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <add-region ref="addRegion" @addRefresh="addRefresh" />
                    <div class="pagination">
                        <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.pageNo" :page-sizes="[10,20,50,100,500]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                        </el-pagination>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <el-dialog class="drawer-title" title="分级地区" :visible.sync="dialogFormVisible" width="450px" center @close="closeImportDialog">

        <div style="text-align: center;">
            <el-tabs class="drawer-item">导入模板请使用主页面导出数据的模板</el-tabs>
            <el-upload drag :before-upload="beforeUploadFile" :show-file-list="false" :action=FILE_ACTION :on-success="handleFileSuccess" accept="Excel/*" :multiple="false">

                <p>点击上传(可拖拽上传)</p>
            </el-upload>
            <p style="font-size: 18px;color: #888888;">文件大小不超过20MB</p>

        </div>
    </el-dialog>

</div>
</template>

<script>
import vHeader from "./Header.vue";
import vSidebar from "./Sidebar.vue";
import addRegion from './addRegion'
import {
    region_list_page,
    region_list_all,
    country_list_all,
    region_del,
    region_del_all,
    region_list_getRegion,
    region_list_getRegionByCountry,
    region_list_getRegion2ByRegion

} from '../../api';
import {
    dealResult
} from "../../api/common";
export default {
    name: "AdminRegion",
    components: {
        vHeader,
        vSidebar,
        addRegion
    },
    data() {

        return {
            delVisible: false,
            delData: {},
            files: null,
            decimalPart: '', // 小数点后的字符
            msg: null,
            moveVisible: false,
            listLoading: false,
            FILE_ACTION: '',

            lander: {},
            trashNum: 0,
            typelist: [],
            countrylist: [],
            regionlist: [],
            religionlist: [],
            languagelist: [],
            partylist: [],
            tableData: [],
            contypelist: [{
                    value: '线上',
                    label: '线上'
                },
                {
                    value: '线下',
                    label: '线下'
                }

            ],
            deleteSeleteData: {},
            query: {
                pageNo: 1,
                pageSize: 10
            },
            pageTotal: 0,

            topbestVisible: false,
            dialogFormVisible: false,
            topbestData: {
                id: '',
                start: '',
                end: '',
            },

        };
    },
    methods: {

        addRefresh() {
            this.reload()
        },

        // 刷新数据
        reload() {
            this.handleSearch()
        },

        // 导入记录
        importDetail() {
            this.$confirm('导入前请确保数据格式正确，否则可能导入不成功?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                this.dialogFormVisible = true
            })
        },

        handleChange() {
            this.regionlist = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            region_list_getRegionByCountry(this.query).then((response) => {
                this.regionlist = response.data.obj
            })
        },

        beforeUploadFile(file) {
            const isLt2M = file.size / 1024 / 1024 < 20;
            if (file.name.includes('.')) {
                this.decimalPart = file.name.split('.')[1]; // 分割字符串并获取小数点后的部分
                if (this.decimalPart !== 'xlsx') {
                    return this.$message.error('请上传后缀为xlsx的Excel文件!');
                }
            }
            if (!isLt2M) {
                this.$message.error('上传的Excel文件大小不能超过 20MB!');
                return isLt2M;
            }

            this.loading = this.$loading({
                lock: true,
                text: "上传中，请稍等,,,,",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.5)",
            });
        },

        handleFileSuccess(res) {
            this.loading.close();
            dealResult(res);
            if (res.status == 1) {
                this.$message.success('上传成功');
                this.dialogFormVisible = false
                this.getPage();

            } else {
                this.$message.error(res.msg);
            }

        },

        handleClick(row) {
            this.$refs.table.toggleRowSelection(row)
        },

        // 导出选中
        handleExportSome() {
            if (
                !this.$refs.table.selection || this.$refs.table.selection.length < 1
            ) {
                this.$message({
                    message: '未选中任何记录',
                    type: 'warning'
                })
                return
            }
            this.redirectData = this.deleteSeleteData
            const loading = this.$loading({
                lock: true,
                text: '正在导出...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            // xlsx文件最大1048576行。目前暂定最大导出1万行
            // fetchList({ page: 1, limit: -1 }, {}).then((response) => {
            import('@/utils/Export2Excel').then((excel) => {
                 const tHeader = [
                        '国家',
                        '一级地区',
                        '二级地区',
                        '备注'
                    ]
                    const filterVal = [
                        'country',
                        'region',
                        'region2',
                        'remark'
                    ]
                const data = this.formatJson(filterVal, this.redirectData)

                loading.close()

                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: this.filename,
                    autoWidth: this.autoWidth,
                    bookType: this.bookType
                })
            })
            // })
        },
        // 全部导出
        handleExport() {

            const loading = this.$loading({
                lock: true,
                text: '正在导出...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            // this.listLoading = true
            // xlsx文件最大1048576行。目前暂定最大导出1万行
            region_list_all(this.query).then((response) => {

                import('@/utils/Export2Excel').then((excel) => {
                    const tHeader = [
                        '国家',
                        '一级地区',
                        '二级地区',
                        '备注'
                    ]
                    const filterVal = [
                        'country',
                        'region',
                        'region2',
                        'remark'
                    ]

                    const data = this.formatJson(filterVal, response.data.obj)
                    loading.close()
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: this.filename,
                        autoWidth: this.autoWidth,
                        bookType: this.bookType
                    })
                })
            })
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) =>
                filterVal.map((j) => {
                    if (j === 'timestamp') {
                        return parseTime(v[j])
                    } else {
                        return v[j]
                    }
                }),
            )
        },

        closeImportDialog() {
            // 清空上传excel列表
            document.getElementById('file').value = ''
        },

        handleAdd() {
            this.$refs.addRegion.open().then((that) => {
                that.initData(null, 'add')
            })
        },
        handleEdit(row) {
            this.$refs.addRegion.open().then((that) => {
                that.initData(row, 'edit')
            })
        },

        // 查询操作
        handleSearch() {
            this.query.pageNo = 1;
            this.getPage();
        },

        // 分页导航
        handlePageChange(val) {
            this.query.pageNo = val;
            this.getPage();
        },
        handleSizeChange(val) {
            this.query.pageNo = 1;
            this.query.pageSize = val;
            this.getPage();
        },

        // 删除行
        handleDelete(row) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                }
                region_del(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
            })
        },
        handleRowSelect(selectionChange) {
            this.deleteSeleteData = selectionChange
        },
        handleDeleteAll() {
            this.$confirm('注意！此操作将永久删除全部记录, 请谨慎操作，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                }
                region_del_all(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            })
        },

        handleDeleteSelect() {
            this.DeleteData = this.deleteSeleteData
            this.deleteSeleteData
            if (this.deleteSeleteData.length > 0) {
                this.$confirm('此操作将永久删除选中记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((res) => {
                    let o = {
                        uid: this.lander.uid,
                        token: this.lander.token,
                    }
                    this.DeleteData.forEach(element => {
                        o.id = element.id
                        region_del(o)

                    })
                    this.getPage();
                    this.$message({
                        type: 'info',
                        message: '删除成功'
                    })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请选择要删除的记录'
                })
            }
        },

        //获取列表数据
        getPage() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.listLoading = true
            region_list_page(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.tableData = res.data.obj.list
                    this.pageTotal = res.data.obj.total //该页总共多少条记录

                } else {
                    this.$message.error(res.data.msg)
                }
                this.listLoading = false

            })
        },
        //去重获取列表数据
        // getItems() {
        //     this.query.uid = this.lander.uid;
        //     this.query.token = this.lander.token;

        //     region_list_getRegion(this.query).then((res) => {
        //         this.regionlist = res.data.obj
        //     })
        // },

        //获取国家清单数据
        getCountry() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;

            country_list_all(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.countrylist = res.data.obj
                    // this.pageTotal = res.data.obj.total //该页总共多少条记录
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        }

    },
    mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        //去后端查询所有的用户给tableData赋值
        this.getPage();
        this.getCountry();
        // this.getItems();
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.faceimg = this.lander.faceimg;
        this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/region/regionlist/importExcel?uid=' + this.lander.uid + "&token=" + this.lander.token;
        if (this.lander.role == '100') {

        }
        if (this.lander.role == '50') {

        }

    }
}
</script>

<style scoped>
.handle-box {
    margin-bottom: 5px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
    width: 150px;
}

.content-box-region {
    position: absolute;
    left: 200px;
    right: 0;
    top: 0px;
    bottom: 0;
    padding-bottom: 30px;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #f0f0f0;
}

.filter-container-right {
    float: right;
}

.pagination {
    display: inline-block;
    padding-left: 200px;
    margin: 20px 0;
    border-radius: 4px;
}

.drawer-item {
    color: rgba(0, 0, 0, .65);
    font-size: 16px;
    padding: 12px 0;
}

.drawer-title {
    margin-bottom: 1px;
    margin-top: 15px;
    color: rgba(0, 0, 0, .85);
    font-size: 22px;
    line-height: 22px;
}

/*滚动条的宽度*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 10px;
}

/*滚动条滑块*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #409eff;
    border-radius: 3px;
}
</style>
